import lessRequire from '../../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import Filters from '../../shared/filters/main';
import Table from '../components/table/conversions/main';
import Save from '../components/save-export/main';
import Calendar from '../../shared/calendar/main';
import SwitchStats from '../components/switch/main';
import CurrencySwitch from '../../shared/currency-switch';
import MasterSwitch from '../components/master-switch/main';

lessRequire('modules/statistics/conversions/main.less');

import switchStatsLinkConfig from '../shared/switch-cfg.js';

const isRocket = process.env.CPA_ENV === 'rocket';

const Main = renderViewsState(props =>
	<Animate>
		<div className="container">
			<div className="container__content goals-wrap">
				<div className="container__content-title">
					<h2 className="font-proxima-nova-bold">{props.intl('Статистика')}</h2>
					<SwitchStats links={switchStatsLinkConfig} intl={props.intl} />
					{!isRocket && (
						<div className="goals-wrap-position__currency">
							<CurrencySwitch
								listOfCurrencies={props.listOfCurrencies}
								activeCurrency={props.activeCurrency}
								onSwitch={props.changeCurrency} />
						</div>
					)}
					{ props.isMaster &&
						<MasterSwitch options={props.masterSwitchConfig} onSwitch={props.applyMasterSwitch} intl={props.intl} />
					}
				</div>
				<div className="container__content-body">
					<div className="goals-wrap__control">
						<Filters {...props} filterApply={props.conversionsFilterApply} />
						<div className="goals-wrap__control-bottom clearfix">
							<button className="reset-btn" onClick={e => props.statsReset()} />
							<button className="submit-btn" onClick={e => props.statsApply()}>{props.intl('Применить')}</button>
							<Save
								{...props.savedFilters}
								onToggle={props.savedFiltersToggle}
								onApply={props.savedFiltersApply}
								onSave={props.savedFiltersSave}
								onExport={props.statExport}
								intl={props.intl}
							/>
							<div className="calendar-position">
								<Calendar
									{...props.calendar}
									onInit={props.calendarInit}
									onToggle={props.calendarToggle}
									onChange={props.calendarChange}
									onApply={props.calendarApply}
									intl={props.intl}
								/>
							</div>
						</div>
					</div>
					<Table
						tableRows={props.dataTable.paginatedData.data}
						showMore={props.pagination().showMore}
						isCanNotMoveToNext={props.dataTable.paginatedData.isCanNotMoveToNext}
						{...props}
					/>
				</div>
			</div>
		</div>
	</Animate>
);

export default connect(
	state  => {
		return {
			data: selectors.getData(state),
			dataTable: selectors.getTableData(state),
			filters: selectors.getFilters(state),
			appliedFilters: selectors.getAppliedFilters(state),
			calendar: selectors.getCalendar(state),
			savedFilters: selectors.getSavedFilters(state),
			cancellationReasonsList: selectors.getCancellationReasonsList(state),
			conversionStatusesList: selectors.getConversionStatusesList(state),
			progressBar: selectors.getProgressBar(state),
			listOfCurrencies: selectors.getListOfCurrencies(state),
			activeCurrency: selectors.getActiveCurrency(state),
			gendersList: selectors.getGendersList(state),
			masterSwitchConfig: selectors.getMasterSwitchConfig(state),
			isMaster: selectors.getIsMasterStatus(state),
			error: selectors.getError(state),
			intl: selectors.getIntl(state)
		};
	},
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/conversions/main.js